import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/** Compact markdown renderer for chat bubbles. */
export default function Markdown({ children }) {
  return (
    <div className="prose prose-sm max-w-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: (props) => <p className="my-1.5 leading-relaxed" {...props} />,
          strong: (props) => <strong className="text-primary font-semibold" {...props} />,
          em: (props) => <em className="italic" {...props} />,
          ul: (props) => <ul className="my-2 ml-4 list-disc space-y-1" {...props} />,
          ol: (props) => <ol className="my-2 ml-4 list-decimal space-y-1" {...props} />,
          h1: (props) => <h3 className="font-serif-display text-2xl text-primary mt-3 mb-1" {...props} />,
          h2: (props) => <h3 className="font-serif-display text-xl text-primary mt-3 mb-1" {...props} />,
          h3: (props) => <h4 className="font-serif-display text-lg text-primary mt-2 mb-1" {...props} />,
          h4: (props) => <h5 className="font-medium text-foreground mt-2 mb-1" {...props} />,
          code: ({ inline, children, ...props }) =>
            inline
              ? <code className="px-1 py-0.5 rounded bg-muted text-foreground/90 text-[0.9em]" {...props}>{children}</code>
              : <pre className="bg-muted rounded-xl p-3 overflow-x-auto my-2 text-xs"><code {...props}>{children}</code></pre>,
          a: (props) => <a className="underline text-secondary hover:text-secondary/80" target="_blank" rel="noreferrer" {...props} />,
          blockquote: (props) => <blockquote className="border-l-2 border-secondary pl-3 italic text-foreground/80 my-2" {...props} />,
          table: (props) => <div className="overflow-x-auto my-2"><table className="text-sm border-collapse" {...props} /></div>,
          th: (props) => <th className="text-overline px-2 py-1 border-b border-border text-left" {...props} />,
          td: (props) => <td className="px-2 py-1 border-b border-border" {...props} />,
          hr: () => <hr className="my-3 border-border" />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
